module.exports = __webpack_public_path__ + "img/squishie-blue.c3547bca.gif";